// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";

type Props = {
  class?   : string,
  invalid? : boolean,
};

export default class Input extends PureComponent {
  props: Props;

  componentDidMount() {
    if (this.props.autoFocus && this.base) {
      this.base.focus();
    }
  }

  render({ invalid, autoFocus, ...rest }: Props) {
    return (
      <input
          {...rest}
          className={classNames(
            this.props["class"],
            styles.block,
            {[styles.invalid]: invalid}
          )}
      />
    );
  }
}
